<ng-container *ngIf="type">
  <div *ngIf="[1].indexOf(type) > -1" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="[2,5,6].indexOf(type) > -1" class="icon speed">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">speed</mat-icon>
  </div>
  <div *ngIf="type == 3" class="icon thermostat">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">thermostat</mat-icon>
  </div>
  <div *ngIf="type == 4" class="icon energy_savings_leaf">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">energy_savings_leaf</mat-icon>
  </div>
  <div *ngIf="type == 7" class="icon cloud_queue">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">cloud_queue</mat-icon>
  </div>
  <div *ngIf="type == 8" class="icon gas_meter">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">gas_meter</mat-icon>
  </div>
  <div *ngIf="type == 9" class="icon water">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">water</mat-icon>
  </div>
  <div *ngIf="type == 10" class="icon electric_meter">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">electric_meter</mat-icon>
  </div>
  <div *ngIf="type == 11" class="icon local_florist">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 12" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <!--Nuevos disposotivos-->
  <div *ngIf="type == 13" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 14" class="icon speed">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">speed</mat-icon>
  </div>
  <div *ngIf="type == 15" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 16" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 17" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 18" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 19" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 20" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 21" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 22" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 23" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 24" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 25" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 26" class="icon thermostat">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">thermostat</mat-icon>
  </div>
  <div *ngIf="type == 27" class="icon cloud_queue">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">cloud_queue</mat-icon>
  </div>
  <div *ngIf="type == 28" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 29" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 30" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 31" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 32" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 33" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 34" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 35" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 36" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 37" class="icon speed">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">speed</mat-icon>
  </div>
  <div *ngIf="type == 38" class="icon speed">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">speed</mat-icon>
  </div>
  <div *ngIf="type == 39" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 40" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 41" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 42" class="icon local_florist2">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">local_florist</mat-icon>
  </div>
  <div *ngIf="type == 43" class="icon gas_meter">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">gas_meter</mat-icon>
  </div>
  <div *ngIf="type == 44" class="icon energy_savings_leaf">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">energy_savings_leaf</mat-icon>
  </div>
  <div *ngIf="type == 45" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 46" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 47" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 48" class="icon water">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">water</mat-icon>
  </div>
  <div *ngIf="type == 49" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 50" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 51" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 52" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>
  <div *ngIf="type == 53" class="icon layers">
    <mat-icon class="icon" [ngStyle]="getSize()" inline="true">layers</mat-icon>
  </div>



  <p *ngIf="type && positionVisible">Sensor {{ position }}</p>
</ng-container>
